var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.repsHistory.length > 0
        ? _c("div", { staticClass: "row mb-2 mt-0" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "col-6 pr-4 text-right" })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.repsHistory, function(rep, index) {
        return _c("MenteeRepHistoryReview", {
          key: rep.id,
          attrs: {
            repTask: _vm.formatRepTask(rep),
            menteeFirstName: _vm.menteeFirstName,
            menteeShortName: _vm.menteeShortName,
            menteeId: _vm.menteeId,
            alignApproveDenyBtns: "type4",
            action: "rep_history_review",
            clockIconPositionClass: "clock-icon-position-middle"
          },
          on: { closeMenteeEditRepModal: _vm.closeMenteeEditRepModal }
        })
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-6 pl-4" }, [
      _c("div", { staticClass: "text-uppercase font-weight-bold" }, [
        _vm._v("Rep History")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66b988e3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66b988e3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/manager/mentee_rep_history.vue
// module id = null
// module chunks = 